<template>
  <div class="centerAll">
    <div v-if="loading" class="loadingholder">
      <img class="spinner" src="@/assets/loader.gif" alt="" />
      <img class="loaderlock" src="@/assets/icons/enter-app/lock-icon.png" alt="" />
    </div>
    <div class="box" :class="{ blur: loading }">
      <div v-if="action == 'login'" class="half1">
        <form action="#" @submit.prevent="submit">
          <div class="form">
            <h1 style="margin-bottom:0;">Log In</h1>
            <!-- <span @click="action = 'register'" class="externlink">Klik hier om een account te maken</span> -->

            <div class="row"></div>
            <div class="row">
              <label for="email">Email-adres</label>
              <div class="input-holder">
                <img src="@/assets/icons/enter-app/email-icon.png" alt="" />
                <input type="email" class="input" placeholder="Email-adres" name="email" value required v-model="form1.email" />
              </div>
            </div>
            <div class="row">
              <label for="email">Wachtwoord</label>
              <div class="input-holder">
                <img src="@/assets/icons/enter-app/lock-icon.png" alt="" />
                <input type="password" class="input" placeholder="Wachtwoord" name="password" value required v-model="form1.password" />
              </div>
            </div>
            <div class="row"><span @click="action = 'wachtwoordreset'">Wachtwoord vergeten?</span></div>
            <div v-if="!error" class="row"></div>
            <div class="row">
              <!-- Place for errors! -->
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <button type="submit">Login</button>
            </div>
          </div>
        </form>
      </div>
      <div v-if="action == 'wachtwoordreset'" class="half1">
        <form action="#" @submit.prevent="submit2">
          <h1 v-if="verzonden" style="margin-bottom:5px;font-size:30px">Check je inbox voor instructies</h1>

          <div v-if="!verzonden" class="form">
            <h1 style="margin-bottom:5px;font-size:30px">Wachtwoord vergeten</h1>

            <div class="row"></div>
            <div class="row">
              <label for="email">Email</label>
              <div class="input-holder">
                <img src="@/assets/icons/enter-app/email-icon.png" alt="" />
                <input type="email" class="input" placeholder="Email-adres" name="email" value required v-model="form2.email" />
              </div>
            </div>
            <span @click="action = 'login'">Terug naar inloggen</span>
            <div class="row"></div>
            <div v-if="!error" class="row"></div>
            <div class="row">
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <button type="submit2">Ontvang email instructie</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
// import db from '../firebase/firebaseInit';

export default {
  data() {
    return {
      verzonden: false,
      action: 'login',
      loading: false,
      form1: {
        email: '',
        password: ''
      },
      form2: {
        name: '',
        email: '',
        password: ''
      },
      error: null
    };
  },
  methods: {
    submit() {
      this.loading = true;
      setTimeout(() => {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.form1.email, this.form1.password)
          .then(() => {
            // this.$router.replace({ name: 'Home' });
          })
          .catch((err) => {
            this.error = err.message;
            this.loading = false;
          });
      }, 1400);
    },
    submit2() {
      this.loading = true;
      setTimeout(() => {
        firebase
          .auth()
          .sendPasswordResetEmail(this.form2.email)
          .then(() => {
            this.loading = false;
            this.verzonden = true;
          })
          .catch((err) => {
            this.error = err.message;
          });
      }, 800);
    }
  }
};
</script>

<style scoped>
button {
  color: #fff;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 12px 14px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: #0475f2;
  transition: 0.25s;
}
button:hover {
  color: #fff;
  background-color: #0475f2;
  opacity: 0.75;
}
button:active {
  color: #fff;
  background-color: #1b4d8d;
}
.externlink:hover {
  text-decoration: underline;
}
.externlink {
  font-size: 15px;
  color: #2f77db;
  padding: 8px 0;
  cursor: pointer;
  padding-top: 20px;
}

.loadingholder {
  position: absolute;
  background-color: white;
  padding: 20px;
  border-radius: 100%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 1;
}
.loaderlock {
  position: absolute;
  transform: scale(0.8);
  image-rendering: pixelated;
}
.spinner {
  transform: scale(1.4);
  border-radius: 100%;
}

.blur {
  filter: blur(6px);
}

.alert {
  color: red;
  font-size: 15px;
  padding: 10px;
  margin-bottom: 20px;
  background-color: rgba(255, 0, 0, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centerAll {
  display: flex;
  align-items: center;
  justify-content: center;
}
.box {
  transition: 0.3s;
  background-color: #fff;
  /* width: 90%; */
  /* height: 90%; */
  /* display: flex; */
  /* max-width: 1340px; */
  /* max-height: 900px; */
  /* box-shadow: 0 100px 80px rgb(00, 00, 00, 0.2); */
}
.half1 {
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;
  min-width: 450px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: rgb(00, 00, 00, 0.4) !important;
  font-size: 13px;
  text-align: left;
}

.form label {
  font-size: 14px;
  padding-bottom: 6px;
}
.row {
  display: flex;
  flex-direction: column;
  padding: 0 0 26px 0;
}
.input-holder {
  position: relative;
}
.input-holder img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding-top: 1px;
  left: 16px;
  width: 20px;
  height: 20px;
  opacity: 0.35;
}
.input {
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1.5px solid #e3e3e3;
  padding: 17px 0 17px 42px;
  font-weight: 500;
  font-size: 16px;
  color: #000;
}
.input::placeholder {
  color: #000;
  opacity: 0.4;
}

.form h1 {
  margin-top: 0;
  color: #000;
  margin-bottom: 36px;
}

.half2 {
  width: 100%;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
</style>
